// extracted by mini-css-extract-plugin
export default {"about":"About_about__tFYRZ","textContainer":"About_textContainer__xf-Bb","imageContainer":"About_imageContainer__EY1Kf","image":"About_image__EorJG"};